import { createFileRoute } from '@tanstack/react-router';

import { BreadcrumbItemProps } from '@/features/admin/components/AdminPageHeader';
import { OrganizationExplorerRoot } from '@/features/manage-orgs/components/explorer/OrganizationExplorerRoot';
import { getOrganizationQueryOptions } from '@/features/manage-orgs/queries/getOrganization';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/_app/app/admin-section/orgs/$sourcedId')(
  {
    component: RouteComponent,
    beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
    loaderDeps: ({ search }) => ({
      search,
    }),
    loader: async ({ context, params }) => {
      if (!params.sourcedId) {
        return;
      }

      await context.queryClient.prefetchQuery(
        getOrganizationQueryOptions({
          sourcedId: params.sourcedId,
        })
      );
    },
    ssr: false,
  }
);

function RouteComponent() {
  const { sourcedId } = Route.useParams();

  const breadcrumbItems: BreadcrumbItemProps[] = [
    {
      label: 'Home',
      link: { to: '/app' },
    },
    {
      label: 'Administration',
      link: { to: '/app' },
    },
    {
      label: 'Organizations',
      link: { to: '/app/admin-section/orgs' },
    },
    {
      label: 'Organization Explorer',
      link: {
        to: '/app/admin-section/orgs/$sourcedId',
        params: { sourcedId },
      },
    },
  ];

  return (
    <AppPageContent className="overflow-hidden">
      <AppPageHeader breadcrumbItems={breadcrumbItems} />
      <OrganizationExplorerRoot />
    </AppPageContent>
  );
}
